import React, { useContext } from 'react';
import { st, classes } from './ViewRow.st.css';
import { st as stDD, classes as classesDD, } from '../PermissionsDropdown/PermissionsDropdown.st.css';
import AvatarRole from './AvatarRole';
import PermissionsDropdown from '../PermissionsDropdown/PermissionsDropdown';
import { TPAComponentsContext } from 'wix-ui-tpa';
function ViewRow(props) {
    const { mobile, rtl } = useContext(TPAComponentsContext);
    const avatarData = {
        role: props.role,
        description: props.description,
        icon: props.icon,
        displayDescription: !mobile,
        roleID: props.id,
    };
    const { options, onChange, isDisabled, selectedPermission, id, containerRef, } = props;
    const permissionChange = (permissionId) => {
        if (onChange) {
            onChange({ permissionId, id });
        }
    };
    return (React.createElement("div", { className: st(classes.mainContainer, { mobile, rtl }) },
        React.createElement(AvatarRole, { ...avatarData, className: st(classes.avatarRoleContainer) }),
        React.createElement(PermissionsDropdown, { ariaLabelledBy: `role${id} role${id}_desc`, className: stDD(classesDD.viewRowDropdown, { mobile, rtl }), options: options, disabled: isDisabled, value: selectedPermission, onChange: permissionChange, containerRef: containerRef })));
}
export default ViewRow;
//# sourceMappingURL=ViewRow.js.map